// @flow
import React, { Fragment } from 'react';

type Props = {
  children: string | null,
  count: string,
};

export function FacetLabel({ children, count }: Props) {
  if (!children) {
    // Safeguard: API can return facets with null names, that must be ignored.
    return null;
  }
  return (
    <Fragment>
      <span className="capitalize">{children.toLowerCase()}</span>
      <span className="mx-2 font-bold text-gray-medium">({count})</span>
    </Fragment>
  );
}
